import { AISummaryEvents } from './aiSummaryEvents';
import { AssessmentEvents } from './assessmentEvents';
import { CarePlanEvents } from './carePlanEvents';
import { DischargePlanEvents } from './dischargePlanEvents';
import { DocumentCenterEvents } from './documentCenterEvents';
import { GroupClassEvents } from './groupClassEvents';
import { ImageEvents } from './imageEvents';
import { InquiryEvents } from './inquiryEvents';
import { MaiChatEvents } from './maiChatEvents';
import { NoteEvents } from './notesEvents';
import { OverviewPageEvents } from './overviewPageEvents';
import { PatientActionEvents } from './patientActionEvents';
import {
  AppointmentCancellationEvents,
  EditAppointmentEvents,
  PatientClinicalEvents,
  PatientEvents,
  PatientScheduleAppointmentEvents,
} from './patientEvents';
import { PatientCalendarEvents } from './patientsCalendarEvents';
import { ProfileEventsAdmin, ProfileEventsMaud } from './profileEvents';
import { ProviderAssignmentAnalyticsEvents } from './providerAssignmentEvents';
import { ProviderDashboardEvents } from './providerDashboardEvents';
import { DashboardV2Events } from './dashboardV2Events';
import { SessionGuideEvents } from './sessionGuideEvents';
import { SMTEvents } from './smtEvents';
import { SurveyAccordionEvents } from './surveyAccordionEvents';
import { TaskEvents } from './taskEvents';
import { TimerEvents } from './timerEvents';
import { TreatmentEpisodeEvents } from './treatmentEpisodeEvents';
import { UserEvents } from './userEvents';
import { MessagesEvents } from '~/analytics/messagesEvents';
import { SafetyRiskAlertEvents } from './safetyRiskAlertEvents';
import { GroupSectionEvents } from './groupSectionEvents';

const AnalyticsEvents = {
  ...AISummaryEvents,
  ...AssessmentEvents,
  ...EditAppointmentEvents,
  ...GroupClassEvents,
  ...GroupSectionEvents,
  ...ImageEvents,
  ...InquiryEvents,
  ...MaiChatEvents,
  ...OverviewPageEvents,
  ...PatientActionEvents,
  ...PatientCalendarEvents,
  ...PatientEvents,
  ...NoteEvents,
  ...UserEvents,
  ...ProfileEventsMaud,
  ...ProfileEventsAdmin,
  ...PatientClinicalEvents,
  ...PatientScheduleAppointmentEvents,
  ...ProviderAssignmentAnalyticsEvents,
  ...ProviderDashboardEvents,
  ...DashboardV2Events,
  ...SessionGuideEvents,
  ...SMTEvents,
  ...SurveyAccordionEvents,
  ...TimerEvents,
  ...TreatmentEpisodeEvents,
  ...MessagesEvents,
  ...AppointmentCancellationEvents,
  ...CarePlanEvents,
  ...DischargePlanEvents,
  ...DocumentCenterEvents,
  ...TaskEvents,
  ...SafetyRiskAlertEvents,
};

export default AnalyticsEvents;

export type AnalyticsEvent =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];

export {
  AssessmentEvents,
  InquiryEvents,
  NoteEvents,
  ProviderAssignmentAnalyticsEvents,
  ProviderDashboardEvents,
  TreatmentEpisodeEvents,
};
